import { render } from "./SubscriptionCredits.vue?vue&type=template&id=f180cd52&scoped=true"
import script from "./SubscriptionCredits.vue?vue&type=script&lang=js"
export * from "./SubscriptionCredits.vue?vue&type=script&lang=js"

import "./SubscriptionCredits.vue?vue&type=style&index=0&id=f180cd52&lang=scss&scoped=true"

import exportComponent from "/Users/jason.pollock/Containers/globaltech/packages/fool-wp-commerce/vue-commerce/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f180cd52"]])

export default __exports__